import { Link } from "react-router-dom";

function BecomeAmbassador() {
  return (
    <>
      <section class="py-8 bg-auto bg-image">
        <div class="container my-lg-8">
          <div class="row justify-content-center py-6">
            <div class="col-12">
              <div className="z-2 position-relative">
                <h1 class="mb-2 display-4 text-white fw-bold">
                  <span>Become Ambassador</span>
                </h1>
                <ol class="breadcrumb">
                  <li class="breadcrumb-item lead">
                    <a href="#">Home</a>
                  </li>
                  <li
                    class="breadcrumb-item active lead text-white"
                    aria-current="page"
                  >
                    Become Ambassador
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-7 pb-4">
        <div className="container">
          <h1 class="fw-bold mb-2">
            Join Our Brand{" "}
            <u class="text-primary">
              <span class="text-dark">Ambassador Program?</span>
            </u>
          </h1>
          <p className="lead lh-sm text-dark">
            The swift growth of our community Labs and its blockchain
            applications presents a huge opportunity for enthusiasts who
            understand its enormous potential to become Palak Assure. By helping
            us promote our platform you become part of the next generation of
            global innovation.
          </p>
          <p className="lead lh-sm mt-2">
            We don’t want to limit ourselves to a “business-to-consumer”
            relationship but rather to a much closer relationship in which we’re
            all part of a common goal: democratize blockchain technology for
            Sustainability.
          </p>

          <p className="fs-4 fw-light mb-4 text-secondary lh-sm">
            That’s why we are looking for visionary souls that understand
            blockchain technology’s main goal of decentralizing and transforming
            everyday life, making it more reliable, transparent, and safe.
            Partners that share our vision based on the
            #BlockchainAccessibleForAll idea so that everybody can enjoy its
            benefits easily and accessibly.
          </p>

          <h3>
            Are you excited to join us while we work towards a future powered by
            blockchain?
          </h3>
          <h3 className="text-dark">What are we looking for?</h3>

          <ul className="fs-4 fw-light mb-4 text-secondary lh-sm">
            <li>
              The most important thing is that our ambassadors identify with our
              mission, values, and objectives. If you believe in the
              democratization of blockchain technology, are passionate about
              technology, and enjoy being part of a global and transformative
              project, you are in the right place.
            </li>
            <li>
              Our ambassadors must also be people with great communication and
              media skills, experts in attracting attention by creating valuable
              content: videos, articles in blogs or media, publications in
              networks, specialized forums, etc.
            </li>
            <li>
              Besides, if you have an active presence in your city’s and are
              involved in creating events, forums, round tables both online and
              offline, there is no reason to wait. Sign up now!
            </li>
          </ul>

          <h3>Advantages of being an ambassador</h3>
          <ol className="fs-4 fw-light mb-4 text-secondary lh-sm">
            <li>Rewards & Founding</li>
            <li>Access to exclusive Events</li>
            <li>Improve your Knowledge</li>
            <li>Early Access to Innovative Products</li>
          </ol>

          <h3>What does an ambassador do?</h3>
          <p className="fs-4 fw-light mb-4 text-secondary lh-sm">
            Ambassadors are active members and blockchain technology enthusiasts
            from all countries, cultures, and ethnicities that give voice to the
            our community ecosystem and want to support us in various ways
            promoting our technology.
          </p>
          <h3>They Play 4 Key Roles-</h3>
          <ul className="fs-4 fw-light mb-4 text-secondary lh-sm">
            <li>Commitment & Value Creation</li>
            <li>Local Perspectives</li>
            <li>Support & Representation</li>
            <li>Business Development</li>
          </ul>
        </div>
      </section>

      <section className="pb-8">
        <div className="container mb-2">
          <div className="row pt-2">
            <div className="col-12">
              <div className="row">
                <div className="col-lg-7 col-md-12 mb-4">
                  <span className="badge bg-dark-soft rounded-pill fs-5 px-4 mb-2">
                    <span className="fw-bold">FAQs</span> - Microfinance Bazar
                  </span>
                  <h1 class="fw-bold mb-0">
                    Do you want more{" "}
                    <u class="text-primary">
                      <span class="text-dark">information?</span>
                    </u>
                  </h1>
                  <p className="lead lh-sm mt-2">
                    Dive into our FAQs to find detailed insights, helpful tips,
                    and everything you need to know about Microfinance Bazar.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-12 col-12">
              <div className="mb-4 mb-lg-0 pe-lg-5">
                <img
                  src="/assets/images/home/4.jpg"
                  alt="featured"
                  className="w-100 rounded-5 object-fit-cover"
                  height="500"
                />
              </div>
            </div>
            <div className="col-lg-6 pb-lg-0 pb-4 d-flex align-items-center">
              <div
                className="accordion accordion-flush w-100 pe-lg-5 pe-0 me-lg-5 me-0"
                id="accordionFlushExample"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button px-0 bg-white"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      <h3 className="faqs-text text-dark fw-medium m-0">
                        What is MicrofinanceBazar?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                    style={{}}
                  >
                    <div className="accordion-body px-0">
                      <p className="fs-4 fw-light mb-4 text-secondary lh-sm">
                        MicrofinanceBazar refers to digital Fintech intermediary
                        providing financial services like loans, savings, and
                        insurance to low-income individuals or groups who do not
                        have access to traditional banking services. It helps
                        people start or expand small businesses, improve their
                        living standards, and break the cycle of poverty.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button px-0 bg-white collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      <h3 className="faqs-text text-dark fw-medium m-0">
                        Who is eligible for a MicrofinanceBazar loan?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse show"
                    data-bs-parent="#accordionFlushExample"
                    style={{}}
                  >
                    <div className="accordion-body px-0">
                      <p className="fs-4 fw-light mb-4 text-secondary lh-sm">
                        Eligibility for microfinance loans typically includes:
                        <ul>
                          <li>
                            Income group: Low-income individuals/ females,
                            Physically Disabled, Transgenders.
                          </li>
                          <li>
                            Business/Income source: Small businesses,
                            self-employed individuals, farmers, or those in the
                            informal sector.
                          </li>
                          <li>
                            Geography: Individuals living in rural or semi-urban
                            areas, where access to traditional banking services
                            may be limited.
                          </li>
                          <li>
                            Credit history: MicrofinanceBazar assesses the
                            creditworthiness of borrowers and co-borrowers,
                            which can change depending on the scheme.
                          </li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button px-0 bg-white collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      <h3 className="faqs-text text-dark fw-medium m-0">
                        How much money can I borrow?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                    style={{}}
                  >
                    <div className="accordion-body px-0">
                      <p className="fs-4 fw-light mb-4 text-secondary lh-sm">
                        The minimum loan amount is INR 5,000. The borrower's
                        ability to repay the loan can range loan limit from
                        ₹10,000 to ₹2,00,000, depending on the eligibility.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button px-0 bg-white collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded="false"
                      aria-controls="flush-collapseFour"
                    >
                      <h3 className="faqs-text text-dark fw-medium m-0">
                        How can I repay my monthly loan repayments?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                    style={{}}
                  >
                    <div className="accordion-body px-0">
                      <p className="fs-4 fw-light mb-4 text-secondary lh-sm">
                        You can pay by monthly amortization installments,
                        starting one month after the loan disbursement and
                        payable via the borrower's designated loan-linked
                        Deposit Account with MicrofinanceBazar.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BecomeAmbassador;
